import { TranslationData } from "@/common/lib/types";
import { cn } from "@/lib/tailwind";
import { usePdpContext } from "@/providers/PdpProvider";
import usePdpQueryParams from "@/hooks/usePdpQueryParams";
import { scrollToElementWithOffsets } from "@/apiUtils/commonUtils";

interface IProps {
  className?: string;
  label: string;
  items: Array<{
    label: string;
    code: string;
    info: string;
  }>;
  translations: TranslationData;
  selectedFit: string;
  onSelectFit: (key: string) => Promise<void>;
}

const ProductSizing = ({
  items,
  label,
  className,
  onSelectFit,
  selectedFit,
  translations,
}: IProps) => {
  const { pdpData, setPdpData } = usePdpContext();
  const { updatePdpQueryParams } = usePdpQueryParams();

  return (
    <div className={cn("select-none", className)}>
      <div className="flex justify-between">
        <div className="">
          <h2 className="text-sm font-bold">{label} :</h2>
          {/* <p className="text-sm text-tertiary-6">Measuring Hinge to Hinger</p> */}
        </div>
        {/* <FrameInfoDialog /> */}
      </div>
      <div className="py-4">
        <form className="grid grid-cols-3 gap-[1px]">
          {items?.map((item, idx) => (
            <div
              key={"size" + idx}
              className="relative w-[6.938rem] md:w-[10.125rem]"
              onClick={async () => {
                // if (item.code === selectedFit) return;
                await onSelectFit(item.code);
              }}
            >
              <div
                className={cn(
                  "flex h-12 w-full cursor-pointer flex-col items-center justify-center border border-[#F4F4F4] text-xs",
                  item.code === selectedFit ? "bg-white" : "bg-[#EEEEEE]",
                )}
              >
                {/* <input
                type="radio"
                id={"productVariant" + idx}
                name="productVariant"
                value={item?.code}
                className="hidden"
                checked={item.code === selectedFit}
                /> */}
                {/* <label
                htmlFor={"productVariant" + idx}
                className={cn(
                  "inline-flex w-full cursor-pointer flex-col items-center justify-between border border-[#EEEEEE] py-2 text-sm",
                  item.code === selectedFit ? "bg-white" : "bg-[#EEEEEE]",
                )}
                > */}
                <p
                  className={cn(
                    "text-xs font-medium leading-4 md:text-[0.8125rem]",
                    // selectedFit === item.code && "font-semibold",
                  )}
                >
                  {item?.label}
                </p>
                <p className="text-[0.75rem]">{item?.info}</p>
                {item.code === selectedFit && (
                  <div className="absolute bottom-0 w-full border-b-[3px] border-secondary-1" />
                )}
                {/* </label> */}
              </div>
            </div>
          ))}
        </form>
      </div>
      <button
        role="button"
        className="text-sm font-semibold underline"
        onClick={() => {
          setPdpData({ ...pdpData, productDetailsTab: "sizeAndFit", sizeAndFitChildTab: 1 });
          updatePdpQueryParams({ tab: "sizeAndFit", childTab: "sizeGuide" }, {});
          setTimeout(() => {
            scrollToElementWithOffsets("wrapper", ["nav-header", "dynamic-banner"]);
          }, 100);
        }}
      >
        {translations?.pdp?.pdp_size_guide_tab_label}
      </button>
    </div>
  );
};

export default ProductSizing;